// @ts-check
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import React, { useState } from "react";
import "../App.css";
import "./component.css";
import Link from "./Link";

export function EmailList() {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <div>
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>Join the email list</DialogTitle>
        <DialogContent>
          <div>
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSfA-l_7oN3nTnExGNjJ93giqXbqDBJ0U8HmcXH0d9w9YICUSQ/viewform?usp=sf_link"
              width="550"
              height="600"
              frameBorder="0"
              marginHeight={0}
              marginWidth={0}
            >
              Loading…
            </iframe>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Link onClick={() => setModalOpen(true)}>Join Email List</Link>
    </div>
  );
}
